export const UPDATE_PENDING_REQUESTS_CURRENT_CACHE_KEY =
  'UPDATE_PENDING_REQUESTS_CURRENT_CACHE_KEY';
export const GET_PENDING_REQUESTS_API_REQUEST = 'GET_PENDING_REQUESTS_API_REQUEST';
export const GET_PENDING_REQUESTS_API_SUCCESS = 'GET_PENDING_REQUESTS_API_SUCCESS';
export const GET_PENDING_REQUESTS_API_ERROR = 'GET_PENDING_REQUESTS_API_ERROR';
export const GET_NEXT_PENDING_REQUESTS_SUCCESS = 'GET_NEXT_PENDING_REQUESTS_SUCCESS';
